export class ExamSummary {
    intakeId: number;
    userId: number;
    chiefComplaint: string;
    gender: string;
    intakeDate: any;
    preferredLanguage: string;
    providerName: string;
    providerUserId: any;
    intakeStatus: string;
    patientName: string;
    visitType: string;
    lineOfBusiness: string;
}

export class ExamData {
    allergies: string[];
    careCoordinationNotes: CareCoordinationNotes[];
    chiefComplaint: string;
    hardware: string;
    intakeDate: Date;
    intakeId: number;
    intakeStatus: string;
    patientAge: string;
    patientBirthDate: Date;
    patientGender: string;
    patientHeight: string;
    patientId: number;
    patientMedication: PatientMedication[];
    patientName: string;
    patientState: any;
    patientUploads: PatientHistoryUploads[];
    patientWeight: string;
    preferredLanguage: string;
    preferredPharmacy: PreferredPharmacy;
    providerName: string;
    reasonForVisit:null
    visitWaitTime: string;   
}

export class PreferredPharmacy {
    id: number;
    externalId: number;
    name: string;
    phone: string;
    fax: string;
    address1: string;
    address2: string;
    city: string;
    state: any;
    zip: string;
    active: boolean;
}

export class PatientHistoryUploads {

    description: string;
    UploadFieldName: string;
    fileName: string;
    fileSessionId: string;
}

export class PatientMedication {
    medicationId: number;
    displayName: string;
    quantity: string;
    dispenseUnits: string;
    notes: string;
}

export class CareCoordinationNotes {
    careCoordinatorId: number;
    careCoordinatorName: string;
    note: string;
    dateCreated: any;
}